// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=none"
// @generated from file cad.proto (package puppy.proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { FileInfo } from "./file_pb";
import { file_file } from "./file_pb";
import type { BranchInfo, BranchKind, CommitInfo } from "./version_pb";
import { file_version } from "./version_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cad.proto.
 */
export const file_cad: GenFile = /*@__PURE__*/
  fileDesc("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", [file_file, file_version]);

/**
 * @generated from message puppy.proto.v1.OpenProjectRequest
 */
export type OpenProjectRequest = Message<"puppy.proto.v1.OpenProjectRequest"> & {
  /**
   * 项目 ID
   *
   * @generated from field: uint64 project_id = 1;
   */
  projectId: bigint;

  /**
   * 目标仓库 ID；为空时使用项目根仓库
   *
   * @generated from field: optional uint64 repository_id = 2;
   */
  repositoryId?: bigint | undefined;

  /**
   * 目标分支 ID；为空或 0 时使用仓库默认分支
   *
   * @generated from field: optional uint64 branch_id = 3;
   */
  branchId?: bigint | undefined;

  /**
   * 目标提交 ID；为空时使用目标分支当前 HEAD
   *
   * @generated from field: string commit_id = 4;
   */
  commitId: string;
};

/**
 * Describes the message puppy.proto.v1.OpenProjectRequest.
 * Use `create(OpenProjectRequestSchema)` to create a new message.
 */
export const OpenProjectRequestSchema: GenMessage<OpenProjectRequest> = /*@__PURE__*/
  messageDesc(file_cad, 0);

/**
 * @generated from message puppy.proto.v1.OpenProjectResponse
 */
export type OpenProjectResponse = Message<"puppy.proto.v1.OpenProjectResponse"> & {
  /**
   * 项目 ID
   *
   * @generated from field: uint64 project_id = 1;
   */
  projectId: bigint;

  /**
   * 项目名称
   *
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * 当前打开仓库对应的根 CAD 节点快照；children 直接承载装配子节点。
   *
   * @generated from field: puppy.proto.v1.CadNode project = 3;
   */
  project?: CadNode | undefined;

  /**
   * 总归档包；仅 assembly-single 格式的数据会返回。
   *
   * @generated from field: optional puppy.proto.v1.CadArchiveFile archive_file = 4;
   */
  archiveFile?: CadArchiveFile | undefined;
};

/**
 * Describes the message puppy.proto.v1.OpenProjectResponse.
 * Use `create(OpenProjectResponseSchema)` to create a new message.
 */
export const OpenProjectResponseSchema: GenMessage<OpenProjectResponse> = /*@__PURE__*/
  messageDesc(file_cad, 1);

/**
 * CAD 归档包及其所属版本信息。
 *
 * @generated from message puppy.proto.v1.CadArchiveFile
 */
export type CadArchiveFile = Message<"puppy.proto.v1.CadArchiveFile"> & {
  /**
   * 归档包所属仓库 ID。
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 归档包所属提交 ID。
   *
   * @generated from field: string commit_id = 2;
   */
  commitId: string;

  /**
   * 归档包文件信息。
   *
   * @generated from field: puppy.proto.v1.FileInfo file_info = 3;
   */
  fileInfo?: FileInfo | undefined;
};

/**
 * Describes the message puppy.proto.v1.CadArchiveFile.
 * Use `create(CadArchiveFileSchema)` to create a new message.
 */
export const CadArchiveFileSchema: GenMessage<CadArchiveFile> = /*@__PURE__*/
  messageDesc(file_cad, 2);

/**
 * @generated from message puppy.proto.v1.CadNode
 */
export type CadNode = Message<"puppy.proto.v1.CadNode"> & {
  /**
   * 当前节点所属仓库 ID；同一仓库内的装配子节点返回相同 repository_id。
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 当前视图分支 ID。
   *
   * @generated from field: uint64 branch_id = 2;
   */
  branchId: bigint;

  /**
   * 当前视图分支名。
   *
   * @generated from field: string branch_name = 3;
   */
  branchName: string;

  /**
   * 当前视图提交 ID。
   *
   * @generated from field: string commit_id = 4;
   */
  commitId: string;

  /**
   * 当前节点 commit 的提交说明；commit_id 为空时返回空。
   *
   * @generated from field: string commit_info = 5;
   */
  commitInfo: string;

  /**
   * 当前装配节点类型。
   *
   * @generated from field: puppy.proto.v1.CadFileKind type = 6;
   */
  type: CadFileKind;

  /**
   * 直接装配子节点。
   *
   * @generated from field: repeated puppy.proto.v1.CadNode children = 7;
   */
  children: CadNode[];

  /**
   * 当前仓库该 commit 下全部文件；files[0] 为 `_assembly.json`或者零件文件zip。
   *
   * @generated from field: repeated puppy.proto.v1.FileInfo files = 8;
   */
  files: FileInfo[];

  /**
   * 当前装配实例名称；根节点默认使用仓库名称，子节点使用 `_assembly.json` 中的实例名。
   *
   * @generated from field: string instance_name = 9;
   */
  instanceName: string;

  /**
   * 当前装配实例 ID；优先取当前节点 `_assembly.json` 中的 instance_id，无装配文档的子节点取父文档 child.instance_id。
   *
   * @generated from field: string instance_id = 10;
   */
  instanceId: string;

  /**
   * 节点实例变换矩阵，按 4x4 展平返回，长度固定为 16。
   * 根节点固定返回恒等矩阵；子节点返回 `_assembly.json` child 实例的 transform。
   *
   * @generated from field: repeated double transform = 11;
   */
  transform: number[];
};

/**
 * Describes the message puppy.proto.v1.CadNode.
 * Use `create(CadNodeSchema)` to create a new message.
 */
export const CadNodeSchema: GenMessage<CadNode> = /*@__PURE__*/
  messageDesc(file_cad, 3);

/**
 * 创建子装配体请求
 *
 * @generated from message puppy.proto.v1.CreateSubAssemblyRequest
 */
export type CreateSubAssemblyRequest = Message<"puppy.proto.v1.CreateSubAssemblyRequest"> & {
  /**
   * 项目 ID（version_repositories.id）
   *
   * @generated from field: uint64 project_id = 1;
   */
  projectId: bigint;

  /**
   * 父装配体仓库 ID；根装配体使用项目主仓库 ID
   *
   * @generated from field: uint64 parent_repository_id = 2;
   */
  parentRepositoryId: bigint;

  /**
   * 目标父仓库分支 ID；为空或 0 时默认 parent_repository_id 的默认分支
   *
   * @generated from field: optional uint64 branch_id = 3;
   */
  branchId?: bigint | undefined;

  /**
   * 并发保护：绑定 parent_repository_id 在 branch_id 上的当前 HEAD commit
   *
   * @generated from field: optional string base_commit_id = 4;
   */
  baseCommitId?: string | undefined;

  /**
   * 子装配体名称；空创建模式必填，导入模式为空时按来源推导
   *
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * 可选导入源：用户目录中的 CAD 包文件路径（相对于用户根目录，仅支持 .part.cad / .assembly.cad）
   *
   * @generated from field: optional string input_file_path = 6;
   */
  inputFilePath?: string | undefined;

  /**
   * 可选导入源：版本仓库 ID；与 input_file_path 互斥
   *
   * @generated from field: optional uint64 input_repository_id = 7;
   */
  inputRepositoryId?: bigint | undefined;

  /**
   * 仓库导入源分支 ID；传 input_repository_id 时必填，0 表示默认分支
   *
   * @generated from field: optional uint64 input_branch_id = 8;
   */
  inputBranchId?: bigint | undefined;

  /**
   * 仓库导入源提交 ID；为空时使用 input_branch_id 的当前 HEAD
   *
   * @generated from field: optional string input_commit_id = 9;
   */
  inputCommitId?: string | undefined;

  /**
   * 节点类型；仅空创建模式必填，仅允许 PART/ASSEMBLY；导入模式下类型由导入源决定
   *
   * @generated from field: optional puppy.proto.v1.CadFileKind node_type = 10;
   */
  nodeType?: CadFileKind | undefined;
};

/**
 * Describes the message puppy.proto.v1.CreateSubAssemblyRequest.
 * Use `create(CreateSubAssemblyRequestSchema)` to create a new message.
 */
export const CreateSubAssemblyRequestSchema: GenMessage<CreateSubAssemblyRequest> = /*@__PURE__*/
  messageDesc(file_cad, 4);

/**
 * 创建子装配体响应
 *
 * @generated from message puppy.proto.v1.CreateSubAssemblyResponse
 */
export type CreateSubAssemblyResponse = Message<"puppy.proto.v1.CreateSubAssemblyResponse"> & {
  /**
   * 新创建节点
   *
   * @generated from field: puppy.proto.v1.CadNode node = 1;
   */
  node?: CadNode | undefined;

  /**
   * 本次提交信息
   *
   * @generated from field: puppy.proto.v1.CommitInfo created_commit = 2;
   */
  createdCommit?: CommitInfo | undefined;
};

/**
 * Describes the message puppy.proto.v1.CreateSubAssemblyResponse.
 * Use `create(CreateSubAssemblyResponseSchema)` to create a new message.
 */
export const CreateSubAssemblyResponseSchema: GenMessage<CreateSubAssemblyResponse> = /*@__PURE__*/
  messageDesc(file_cad, 5);

/**
 * 删除子装配体挂载实例请求
 *
 * @generated from message puppy.proto.v1.DeleteSubAssemblyRequest
 */
export type DeleteSubAssemblyRequest = Message<"puppy.proto.v1.DeleteSubAssemblyRequest"> & {
  /**
   * 项目 ID
   *
   * @generated from field: uint64 project_id = 1;
   */
  projectId: bigint;

  /**
   * 父装配体仓库 ID
   *
   * @generated from field: uint64 parent_repository_id = 2;
   */
  parentRepositoryId: bigint;

  /**
   * 目标父仓库分支 ID；为空或 0 时使用默认分支
   *
   * @generated from field: optional uint64 branch_id = 3;
   */
  branchId?: bigint | undefined;

  /**
   * 并发保护；为空时使用当前 HEAD，非空时必须匹配当前 HEAD
   *
   * @generated from field: optional string base_commit_id = 4;
   */
  baseCommitId?: string | undefined;

  /**
   * 待删除的直接子挂载实例 UUID
   *
   * @generated from field: string instance_uuid = 5;
   */
  instanceUuid: string;

  /**
   * 防误删校验：挂载必须引用该子仓库
   *
   * @generated from field: uint64 child_repository_id = 6;
   */
  childRepositoryId: bigint;
};

/**
 * Describes the message puppy.proto.v1.DeleteSubAssemblyRequest.
 * Use `create(DeleteSubAssemblyRequestSchema)` to create a new message.
 */
export const DeleteSubAssemblyRequestSchema: GenMessage<DeleteSubAssemblyRequest> = /*@__PURE__*/
  messageDesc(file_cad, 6);

/**
 * 删除子装配体挂载实例响应
 *
 * @generated from message puppy.proto.v1.DeleteSubAssemblyResponse
 */
export type DeleteSubAssemblyResponse = Message<"puppy.proto.v1.DeleteSubAssemblyResponse"> & {
  /**
   * 本次删除挂载所创建的父仓库提交
   *
   * @generated from field: puppy.proto.v1.CommitInfo created_commit = 1;
   */
  createdCommit?: CommitInfo | undefined;
};

/**
 * Describes the message puppy.proto.v1.DeleteSubAssemblyResponse.
 * Use `create(DeleteSubAssemblyResponseSchema)` to create a new message.
 */
export const DeleteSubAssemblyResponseSchema: GenMessage<DeleteSubAssemblyResponse> = /*@__PURE__*/
  messageDesc(file_cad, 7);

/**
 * 创建装配体分支请求
 *
 * @generated from message puppy.proto.v1.CreateAssemblyBranchRequest
 */
export type CreateAssemblyBranchRequest = Message<"puppy.proto.v1.CreateAssemblyBranchRequest"> & {
  /**
   * 项目 ID
   *
   * @generated from field: uint64 project_id = 1;
   */
  projectId: bigint;

  /**
   * 目标装配节点仓库 ID，必须属于项目装配树节点
   *
   * @generated from field: uint64 repository_id = 2;
   */
  repositoryId: bigint;

  /**
   * 待创建的新分支名
   *
   * @generated from field: string branch_name = 3;
   */
  branchName: string;

  /**
   * 显式来源模式：
   * - source_branch_id / source_commit_id 可同时传
   * - 仅传 source_branch_id 时，使用该分支当前 HEAD
   * - 传 source_commit_id 时，需校验该提交存在于目标仓库
   *
   * @generated from field: optional uint64 source_branch_id = 4;
   */
  sourceBranchId?: bigint | undefined;

  /**
   * @generated from field: optional string source_commit_id = 5;
   */
  sourceCommitId?: string | undefined;

  /**
   * 输入 CAD 包路径模式：
   * - 与 source_branch_id / source_commit_id 互斥
   * - 仅支持用户目录中的 .part.cad / .assembly.cad 单文件包
   *
   * @generated from field: optional string input_file_path = 6;
   */
  inputFilePath?: string | undefined;

  /**
   * 分支用途类型；必填
   *
   * @generated from field: puppy.proto.v1.BranchKind branch_kind = 7;
   */
  branchKind: BranchKind;

  /**
   * 分支负责人用户 ID；普通分支必填且必须为真实用户 ID，非普通分支忽略
   *
   * @generated from field: uint64 assignee_user_id = 8;
   */
  assigneeUserId: bigint;
};

/**
 * Describes the message puppy.proto.v1.CreateAssemblyBranchRequest.
 * Use `create(CreateAssemblyBranchRequestSchema)` to create a new message.
 */
export const CreateAssemblyBranchRequestSchema: GenMessage<CreateAssemblyBranchRequest> = /*@__PURE__*/
  messageDesc(file_cad, 8);

/**
 * 创建装配体分支响应
 *
 * @generated from message puppy.proto.v1.CreateAssemblyBranchResponse
 */
export type CreateAssemblyBranchResponse = Message<"puppy.proto.v1.CreateAssemblyBranchResponse"> & {
  /**
   * 新创建分支信息
   *
   * @generated from field: puppy.proto.v1.BranchInfo branch = 1;
   */
  branch?: BranchInfo | undefined;
};

/**
 * Describes the message puppy.proto.v1.CreateAssemblyBranchResponse.
 * Use `create(CreateAssemblyBranchResponseSchema)` to create a new message.
 */
export const CreateAssemblyBranchResponseSchema: GenMessage<CreateAssemblyBranchResponse> = /*@__PURE__*/
  messageDesc(file_cad, 9);

/**
 * 获取装配节点仓库的分支列表请求
 *
 * @generated from message puppy.proto.v1.ListRepositoryBranchesRequest
 */
export type ListRepositoryBranchesRequest = Message<"puppy.proto.v1.ListRepositoryBranchesRequest"> & {
  /**
   * 项目 ID
   *
   * @generated from field: uint64 project_id = 1;
   */
  projectId: bigint;

  /**
   * 目标装配节点仓库 ID，必须属于项目装配树节点  
   *
   * @generated from field: uint64 repository_id = 2;
   */
  repositoryId: bigint;

  /**
   * 导航节点信息；根节点为空，非空时保留节点信息并补齐导航分支
   *
   * @generated from field: puppy.proto.v1.AssemblyNode node = 3;
   */
  node?: AssemblyNode | undefined;

  /**
   * 可选：按分支用途类型筛选；为空时返回全部类型
   *
   * @generated from field: optional puppy.proto.v1.BranchKind branch_kind = 4;
   */
  branchKind?: BranchKind | undefined;
};

/**
 * Describes the message puppy.proto.v1.ListRepositoryBranchesRequest.
 * Use `create(ListRepositoryBranchesRequestSchema)` to create a new message.
 */
export const ListRepositoryBranchesRequestSchema: GenMessage<ListRepositoryBranchesRequest> = /*@__PURE__*/
  messageDesc(file_cad, 10);

/**
 * 装配节点分支信息
 *
 * @generated from message puppy.proto.v1.RepositoryBranchInfo
 */
export type RepositoryBranchInfo = Message<"puppy.proto.v1.RepositoryBranchInfo"> & {
  /**
   * 分支基础信息
   *
   * @generated from field: puppy.proto.v1.BranchInfo branch = 1;
   */
  branch?: BranchInfo | undefined;

  /**
   * 该分支根装配的直接子节点数
   *
   * @generated from field: int32 child_count = 2;
   */
  childCount: number;
};

/**
 * Describes the message puppy.proto.v1.RepositoryBranchInfo.
 * Use `create(RepositoryBranchInfoSchema)` to create a new message.
 */
export const RepositoryBranchInfoSchema: GenMessage<RepositoryBranchInfo> = /*@__PURE__*/
  messageDesc(file_cad, 11);

/**
 * 获取装配节点仓库的分支列表响应
 *
 * @generated from message puppy.proto.v1.ListRepositoryBranchesResponse
 */
export type ListRepositoryBranchesResponse = Message<"puppy.proto.v1.ListRepositoryBranchesResponse"> & {
  /**
   * 分支列表，按分支名升序
   *
   * @generated from field: repeated puppy.proto.v1.RepositoryBranchInfo branches = 1;
   */
  branches: RepositoryBranchInfo[];

  /**
   * 导航节点信息
   *
   * @generated from field: puppy.proto.v1.AssemblyNode node = 2;
   */
  node?: AssemblyNode | undefined;
};

/**
 * Describes the message puppy.proto.v1.ListRepositoryBranchesResponse.
 * Use `create(ListRepositoryBranchesResponseSchema)` to create a new message.
 */
export const ListRepositoryBranchesResponseSchema: GenMessage<ListRepositoryBranchesResponse> = /*@__PURE__*/
  messageDesc(file_cad, 12);

/**
 * 装配节点数据
 *
 * @generated from message puppy.proto.v1.AssemblyNodeData
 */
export type AssemblyNodeData = Message<"puppy.proto.v1.AssemblyNodeData"> & {
  /**
   * 当前节点实例 UUID；根节点固定为空字符串
   *
   * @generated from field: string instance_uuid = 1;
   */
  instanceUuid: string;

  /**
   * 节点名称
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 节点类型
   *
   * @generated from field: puppy.proto.v1.CadFileKind node_type = 3;
   */
  nodeType: CadFileKind;

  /**
   * 当前节点仓库 ID
   *
   * @generated from field: uint64 repository_id = 4;
   */
  repositoryId: bigint;

  /**
   * 当前节点仓库的分支数量
   *
   * @generated from field: int32 branch_count = 5;
   */
  branchCount: number;

  /**
   * 采纳提交所属分支 ID；未采纳时为 0
   *
   * @generated from field: uint64 adopted_branch_id = 6;
   */
  adoptedBranchId: bigint;

  /**
   * 采纳提交所属分支名；未采纳时为空
   *
   * @generated from field: string adopted_branch_name = 7;
   */
  adoptedBranchName: string;

  /**
   * 采纳提交 ID；未采纳时为空
   *
   * @generated from field: string adopted_commit_id = 8;
   */
  adoptedCommitId: string;

  /**
   * 采纳提交说明；未采纳时为空
   *
   * @generated from field: string adopted_commit_info = 9;
   */
  adoptedCommitInfo: string;
};

/**
 * Describes the message puppy.proto.v1.AssemblyNodeData.
 * Use `create(AssemblyNodeDataSchema)` to create a new message.
 */
export const AssemblyNodeDataSchema: GenMessage<AssemblyNodeData> = /*@__PURE__*/
  messageDesc(file_cad, 13);

/**
 * 装配节点（用于目录浏览；可直接链式继续查询子节点/同级节点）
 *
 * @generated from message puppy.proto.v1.AssemblyNode
 */
export type AssemblyNode = Message<"puppy.proto.v1.AssemblyNode"> & {
  /**
   * 父节点；根节点为空
   *
   * @generated from field: puppy.proto.v1.AssemblyNode parent = 1;
   */
  parent?: AssemblyNode | undefined;

  /**
   * 当前节点数据
   *
   * @generated from field: puppy.proto.v1.AssemblyNodeData data = 2;
   */
  data?: AssemblyNodeData | undefined;

  /**
   * 当前节点导航分支 ID，默认取当前节点仓库默认分支
   *
   * @generated from field: uint64 navigation_branch_id = 3;
   */
  navigationBranchId: bigint;

  /**
   * 当前节点导航分支名，默认取当前节点仓库默认分支
   *
   * @generated from field: string navigation_branch_name = 4;
   */
  navigationBranchName: string;
};

/**
 * Describes the message puppy.proto.v1.AssemblyNode.
 * Use `create(AssemblyNodeSchema)` to create a new message.
 */
export const AssemblyNodeSchema: GenMessage<AssemblyNode> = /*@__PURE__*/
  messageDesc(file_cad, 14);

/**
 * 获取指定分支提交下所有直接子节点请求
 *
 * @generated from message puppy.proto.v1.ListBranchNodesRequest
 */
export type ListBranchNodesRequest = Message<"puppy.proto.v1.ListBranchNodesRequest"> & {
  /**
   * 当前分支视角 ID（version_branches.id）
   *
   * @generated from field: uint64 branch_id = 1;
   */
  branchId: bigint;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大值由服务端限制）
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * 目标提交 ID；为空时使用分支的当前 HEAD
   *
   * @generated from field: string commit_id = 4;
   */
  commitId: string;
};

/**
 * Describes the message puppy.proto.v1.ListBranchNodesRequest.
 * Use `create(ListBranchNodesRequestSchema)` to create a new message.
 */
export const ListBranchNodesRequestSchema: GenMessage<ListBranchNodesRequest> = /*@__PURE__*/
  messageDesc(file_cad, 15);

/**
 * 获取指定分支提交下所有直接子节点响应
 *
 * @generated from message puppy.proto.v1.ListBranchNodesResponse
 */
export type ListBranchNodesResponse = Message<"puppy.proto.v1.ListBranchNodesResponse"> & {
  /**
   * 直接子节点（非递归）
   *
   * @generated from field: repeated puppy.proto.v1.AssemblyNodeData nodes = 1;
   */
  nodes: AssemblyNodeData[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.ListBranchNodesResponse.
 * Use `create(ListBranchNodesResponseSchema)` to create a new message.
 */
export const ListBranchNodesResponseSchema: GenMessage<ListBranchNodesResponse> = /*@__PURE__*/
  messageDesc(file_cad, 16);

/**
 * 搜索装配节点请求
 *
 * @generated from message puppy.proto.v1.SearchAssemblyNodesRequest
 */
export type SearchAssemblyNodesRequest = Message<"puppy.proto.v1.SearchAssemblyNodesRequest"> & {
  /**
   * 项目 ID
   *
   * @generated from field: uint64 project_id = 1;
   */
  projectId: bigint;

  /**
   * 模糊搜索：节点名 / 分支名 / 负责人
   *
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大值由服务端限制）
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message puppy.proto.v1.SearchAssemblyNodesRequest.
 * Use `create(SearchAssemblyNodesRequestSchema)` to create a new message.
 */
export const SearchAssemblyNodesRequestSchema: GenMessage<SearchAssemblyNodesRequest> = /*@__PURE__*/
  messageDesc(file_cad, 17);

/**
 * 搜索装配节点响应
 *
 * @generated from message puppy.proto.v1.SearchAssemblyNodesResponse
 */
export type SearchAssemblyNodesResponse = Message<"puppy.proto.v1.SearchAssemblyNodesResponse"> & {
  /**
   * 搜索结果
   *
   * @generated from field: repeated puppy.proto.v1.AssemblyNode nodes = 1;
   */
  nodes: AssemblyNode[];

  /**
   * 总数
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.SearchAssemblyNodesResponse.
 * Use `create(SearchAssemblyNodesResponseSchema)` to create a new message.
 */
export const SearchAssemblyNodesResponseSchema: GenMessage<SearchAssemblyNodesResponse> = /*@__PURE__*/
  messageDesc(file_cad, 18);

/**
 * 获取指定项目节点在目标提交下的完整子树请求
 *
 * @generated from message puppy.proto.v1.GetCadNodeTreeRequest
 */
export type GetCadNodeTreeRequest = Message<"puppy.proto.v1.GetCadNodeTreeRequest"> & {
  /**
   * 目标节点仓库 ID  
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 目标分支 ID；为空或 0 时使用仓库默认分支
   *
   * @generated from field: uint64 branch_id = 2;
   */
  branchId: bigint;

  /**
   * 目标提交 ID；为空时使用分支的当前 HEAD
   *
   * @generated from field: string commit_id = 3;
   */
  commitId: string;
};

/**
 * Describes the message puppy.proto.v1.GetCadNodeTreeRequest.
 * Use `create(GetCadNodeTreeRequestSchema)` to create a new message.
 */
export const GetCadNodeTreeRequestSchema: GenMessage<GetCadNodeTreeRequest> = /*@__PURE__*/
  messageDesc(file_cad, 19);

/**
 * 获取指定项目节点在目标提交下的完整子树响应
 *
 * @generated from message puppy.proto.v1.GetCadNodeTreeResponse
 */
export type GetCadNodeTreeResponse = Message<"puppy.proto.v1.GetCadNodeTreeResponse"> & {
  /**
   * 目标节点及其全部后代
   *
   * @generated from field: puppy.proto.v1.CadNode node = 1;
   */
  node?: CadNode | undefined;

  /**
   * 总归档包及其版本；仅 assembly-single 格式的数据会返回
   *
   * @generated from field: optional puppy.proto.v1.CadArchiveFile archive_file = 2;
   */
  archiveFile?: CadArchiveFile | undefined;
};

/**
 * Describes the message puppy.proto.v1.GetCadNodeTreeResponse.
 * Use `create(GetCadNodeTreeResponseSchema)` to create a new message.
 */
export const GetCadNodeTreeResponseSchema: GenMessage<GetCadNodeTreeResponse> = /*@__PURE__*/
  messageDesc(file_cad, 20);

/**
 * @generated from enum puppy.proto.v1.CadFileKind
 */
export enum CadFileKind {
  /**
   * @generated from enum value: CAD_FILE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAD_FILE_KIND_PART = 1;
   */
  PART = 1,

  /**
   * @generated from enum value: CAD_FILE_KIND_ASSEMBLY = 2;
   */
  ASSEMBLY = 2,
}

/**
 * Describes the enum puppy.proto.v1.CadFileKind.
 */
export const CadFileKindSchema: GenEnum<CadFileKind> = /*@__PURE__*/
  enumDesc(file_cad, 0);

/**
 * CAD 会话服务
 *
 * @generated from service puppy.proto.v1.CadService
 */
export const CadService: GenService<{
  /**
   * 打开 CAD 项目并返回当前仓库快照
   *
   * @generated from rpc puppy.proto.v1.CadService.OpenProject
   */
  openProject: {
    methodKind: "unary";
    input: typeof OpenProjectRequestSchema;
    output: typeof OpenProjectResponseSchema;
  },
  /**
   * 获取指定项目节点在目标提交下的完整子树
   *
   * @generated from rpc puppy.proto.v1.CadService.GetCadNodeTree
   */
  getCadNodeTree: {
    methodKind: "unary";
    input: typeof GetCadNodeTreeRequestSchema;
    output: typeof GetCadNodeTreeResponseSchema;
  },
  /**
   * 创建子装配体
   *
   * @generated from rpc puppy.proto.v1.CadService.CreateSubAssembly
   */
  createSubAssembly: {
    methodKind: "unary";
    input: typeof CreateSubAssemblyRequestSchema;
    output: typeof CreateSubAssemblyResponseSchema;
  },
  /**
   * 删除子装配体挂载实例
   *
   * @generated from rpc puppy.proto.v1.CadService.DeleteSubAssembly
   */
  deleteSubAssembly: {
    methodKind: "unary";
    input: typeof DeleteSubAssemblyRequestSchema;
    output: typeof DeleteSubAssemblyResponseSchema;
  },
  /**
   * 创建装配体分支
   *
   * @generated from rpc puppy.proto.v1.CadService.CreateAssemblyBranch
   */
  createAssemblyBranch: {
    methodKind: "unary";
    input: typeof CreateAssemblyBranchRequestSchema;
    output: typeof CreateAssemblyBranchResponseSchema;
  },
  /**
   * 获取装配节点仓库的分支列表
   *
   * @generated from rpc puppy.proto.v1.CadService.ListRepositoryBranches
   */
  listRepositoryBranches: {
    methodKind: "unary";
    input: typeof ListRepositoryBranchesRequestSchema;
    output: typeof ListRepositoryBranchesResponseSchema;
  },
  /**
   * 获取指定分支提交下所有直接子节点（非递归）
   *
   * @generated from rpc puppy.proto.v1.CadService.ListBranchNodes
   */
  listBranchNodes: {
    methodKind: "unary";
    input: typeof ListBranchNodesRequestSchema;
    output: typeof ListBranchNodesResponseSchema;
  },
  /**
   * 搜索装配节点（按节点名/分支名/负责人）
   *
   * @generated from rpc puppy.proto.v1.CadService.SearchAssemblyNodes
   */
  searchAssemblyNodes: {
    methodKind: "unary";
    input: typeof SearchAssemblyNodesRequestSchema;
    output: typeof SearchAssemblyNodesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cad, 0);

